"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Link_1 = require("./Link");
const constants_1 = require("../constants");
const Root = styled_1.default.div `
  display: inline-block;
  position: relative;
  background: ${constants_1.Color.DARK_BLUE};
  border-radius: ${constants_1.theme.border.radius.normal}px;
  transform-style: preserve-3d;
  overflow: hidden;
`;
const Grid = styled_1.default.div `
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
`;
const Active = styled_1.default.div(({ itemCount, selectedIndex }) => ({
    position: 'absolute',
    inset: 0,
    width: `${100 / itemCount}%`,
    borderRadius: constants_1.theme.border.radius.normal,
    background: constants_1.Color.MEDIUM_BLUE,
    transform: `translateX(${100 * selectedIndex}%)`,
    transition: `transform ${constants_1.theme.animation.duration}s ease-in-out`,
    zIndex: -1,
}));
const ToggleGroupItem = styled_1.default.button `
  all: unset;
  text-align: center;
  box-sizing: border-box;
  padding: ${constants_1.theme.spacing[1]}px ${constants_1.theme.spacing[2]}px;
  background-color: transparent;
  color: ${(props) => (props.active ? constants_1.Color.WHITE : constants_1.Color.TRANSPARENT_BLUE)};
  transition: color ${constants_1.theme.animation.duration}s ease-in-out;
  cursor: pointer;
  z-index: 1;
`;
const ToggleGroup = ({ items }) => {
    const selectedIndex = items.findIndex((item) => item.active);
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(Grid, { children: items.map((item, index) => ((0, jsx_runtime_1.jsx)(ToggleGroupItem, { as: item.to ? Link_1.Link : 'button', active: item.active, to: item.to, onClick: item.onClick, children: item.label }, index))) }), selectedIndex === -1 ? null : ((0, jsx_runtime_1.jsx)(Active, { itemCount: items.length, selectedIndex: selectedIndex }))] }));
};
exports.ToggleGroup = ToggleGroup;
